module.exports = fox._r("images/events/newyear/snow3.png", __webpack_public_path__ + "images/events/newyear/snow3.png");


//////////////////
// WEBPACK FOOTER
// ./images/events/newyear/snow3.png
// module id = 572
// module chunks = 2